<script>
import { mapGetters } from "vuex";

import currencyMixin from "@/mixins/generic/currencyMixin";

import pricingHelper from "@/utils/helpers/pricingHelper";
import couponHelper from "@/utils/helpers/coupon";
import paymentValidator from "@/utils/validators/payments";

export default {
  mixins: [currencyMixin],

  computed: {
    ...mapGetters("orderScheduler", [
      "date",
      "duration",
      "address",
      "professional"
    ]),

    pricing: function() {
      return pricingHelper.calculatePricing(this.address, this.duration);
    },

    pricingWithDiscount: function() {
      if (!this.professional || !this.professional.active_coupon) {
        return null;
      }

      return couponHelper.applyDiscount(
        this.pricing,
        this.professional.active_coupon
      );
    },

    canPayWithBoleto() {
      return paymentValidator.canPayViaBoleto("orders", this.date);
    },

    labelDaysToPay() {
      return paymentValidator.firstDayToPayViaBoleto();
    }
  }
};
</script>

<template>
  <div class="pricing-content">
    <div class="pricing-info">
      <div v-if="duration" class="pricing">
        <div>
          <span>
            <span class="pink">{{ duration }}</span> HORAS DE LIMPEZA
          </span>

            <div>
              <transition name="fade" mode="in-out">
                <span v-if="pricingWithDiscount" class="original-pricing">
                  de {{ pricing | toCurrency }}
                </span>
              </transition>

              <span class="pink">POR {{ pricingWithDiscount || pricing | toCurrency }}</span>
            </div>
        </div>

        <p>Transporte e alimentação do profissional inclusos.</p>
      </div>

      <span v-else class="pricing-alert">
        É necessário definir a <b>duração</b> da limpeza para calcularmos o <b>valor</b>.
      </span>
    </div>

    <div class="payment-type" v-if="!canPayWithBoleto">
      O dia selecionado permite pagamento apenas via cartão de crédito. Para pagamento via boleto selecione um dia à partir de <span>{{ labelDaysToPay }}</span>.
    </div>
  </div>
</template>

<style scoped>
.pricing-content {
  width: calc(100% - 24px);
  padding: 8px 12px;
  position: relative;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  user-select: none;
  margin-top: 4px;
  background: #fff;
}

.pricing-info {
  text-align: center;
}

.pricing {
  font-weight: 500;
}

.pricing div {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
}

.pricing div:nth-child(2) {
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-left: 12px;
}

.original-pricing {
  font-size: 10px;
  font-weight: 500;
  text-decoration: line-through;
}

.pink {
  color: #af006b;
}

.pricing p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #424242;
  font-weight: 400;
}

.pricing-alert {
  font-size: 14px;
  color: #af006b;
}

.payment-type {
  margin-top: 8px;
  font-size: 12px;
  color: #af006b;
  text-align: center;
}

.payment-type span {
  font-weight: 500;
}

@media (max-width: 360px) {
  .pricing div {
    font-size: 13px;
  }

  .pricing div:nth-child(2) {
    margin-left: 8px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Pricing/Index.vue